/**
 * Import group enum
 */
export enum ImportGroupEnum {
  FlatFile = 1,
  BaringsFlatFile,
  Dcf,
  AxaFlatFile,
  AxaDcf,
  FranceDcf,
  OneReportDcf,
  UsReport
}

/**
 * Mapping that defines, which display value should be used for which enum value
 */
export const ImportGroupMapping = [
  { type: ImportGroupEnum.FlatFile, value: 'Flat File' },
  { type: ImportGroupEnum.BaringsFlatFile, value: 'Flat File' },
  { type: ImportGroupEnum.Dcf, value: 'other' },
  { type: ImportGroupEnum.AxaFlatFile, value: 'Flat File' },
  { type: ImportGroupEnum.AxaDcf, value: 'other' },
  { type: ImportGroupEnum.FranceDcf, value: 'France' },
  { type: ImportGroupEnum.OneReportDcf, value: 'One Report' },
  { type: ImportGroupEnum.UsReport, value: 'US Report' }
];
